import { Component, OnInit, Input, Output, ViewChild, ViewEncapsulation, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment/moment';

import { MatSidenav, MatDialog } from '@angular/material';

import { AlertComponent, DenyComponent } from './shared/common/index';
import { NewsLetterDashboardComponent } from './shared/dashboard/index';

import {
    SessionStorageService, TenantService, PageContentService, LocalDataService,
    ParamService, ParameterConfigService, ConfigService,
    CodedService
} from './core/index.service';
import { PageContent, Tenant, UserState, Screens as Scr } from './core/index.model';

import { UserRole, ParamId } from './core/enumtype';
import { MSG_ConfigErr, MSG_InactiveConfigErr } from './core/messages';
import * as Lang from './core/languages';

import { UserIdleService, UserIdleModule } from 'angular-user-idle';


import { Store } from '@ngrx/store';
import { AppState } from '../app/statemanagement/app.state';
import { ParamInfo } from '../app/core/index.model';
import { Subscription } from 'rxjs';
import { T } from '@angular/core/src/render3';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {

    /**
     * PageContent Model
    */
    public pageContent: PageContent;
    /**
     * Tenant Model
    */
    public tenant: Tenant;
    /**
     * UserState Model
    */
    public userState: UserState;
    /**
     * Screens Model
    */
    public scr: Scr[];

    public response: Scr[];
    /**
     * currentPage will be assigned from route
    */
    currentPage: string;
    /**
     * lang will be assigned from language select option
    */
    lang: string;
    /**
     * Windows current scroll Y (vertical) position will be assigned when scroll the page
    */
    scrollYP: number;


    serviceErr = false;
    /**
     * Fixed Header
    */
    fixed = false;
    /**
     * Cover Header
    */
    coverHeader = true;
    /**
     * Show Header
    */
    showHeader = true;
    /**
     * Show Footer
    */
    showFooter = true;
    /**
     * Mode Index
    */
    modeIndex = 0;

    isSeeSomethingEnabled: boolean = false;

    /**
     * Left Menu Mode
    */
    get mode() { return ['side', 'over', 'push'][this.modeIndex]; }
    /**
     * Fixed Header Height
    */
    get fixedTop() { return this.fixed && this.showHeader && !this.coverHeader ? 64 : 0; }
    /**
     * Fixed Footer Height
    */
    get fixedBottom() { return this.fixed && this.showFooter && !this.coverHeader ? 64 : 0; }

    /**
     * Left Menu
    */
    @ViewChild('start') start: MatSidenav;

    /**
     * IE Should not navigate to previous page when we click the Backspace button
    */
    @HostListener('document:keydown', ['$event']) onKeyDown(evt: KeyboardEvent) {
        if (evt.which === 8 && (evt.srcElement.className.indexOf('mat-select') >= 0 || evt.srcElement.className.indexOf('mat-calendar') >= 0
            || evt.srcElement.className.indexOf('mat-icon-button') >= 0 || evt.srcElement.className == '')) {
            evt.preventDefault();
        }

        this.cmdRestartTimer();
    }

    public showNewsLetterIcon: boolean = false; // Value will assigned from default.component


    parameterValue: Observable<ParamInfo[]>;

    PDFFormrefresh: Subscription;

    hideStaticTitle : boolean = true

    constructor(
        private router: Router,
        private dialog: MatDialog,
        private storageService: SessionStorageService,
        private tenantService: TenantService,
        private pagecontentService: PageContentService,
        private localDataService: LocalDataService,
        private paramService: ParamService,
        public paramConfigService: ParameterConfigService,
        public configService: ConfigService,
        private userIdle: UserIdleService,
        private store: Store<AppState>,
        private codedService : CodedService
    ) {
        this.PDFFormrefresh = this.pagecontentService.LoadFormaction().subscribe(() => {
            this.getPageContent();

        }
        );
    }

    /**
     * ngOnInit() --> Initialize the directive/component after Angular first displays the data-bound properties and sets the directive/component's input properties.
     *
     * Called once, after the first ngOnChanges()
    */

    ngOnInit() {
        this.getUserTenantDetails();
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    //this.currentPage = (event.urlAfterRedirects.indexOf('/report/newonlinereport') > -1) ? '/report/newonlinereport' : event.urlAfterRedirects;
                    this.currentPage = event.urlAfterRedirects;
                    this.getPageContent();
                    this.scrollYP = 0;
                    document.getElementById("divContent").scrollTop = 0;
                }
            });
        this.setUserAccessKey();

        this.idleUserInitialization();
    }

    setTheme(){
        let juris = JSON.parse(sessionStorage.getItem('userinfo'))
        //console.log(juris);
        if(juris.Theme !== null || juris.Theme != ''){
            this.getCodedList(1990, juris.Theme)
        }
        
    }

    //Token authentication using Key

    setUserAccessKey() {
        this.storageService.setUserAccessKey(this.configService.getConfiguration().PhoenixKey);
    }


    /**
     * Assigning Scroll Y Position to scrollYP
     *
     * scrollYP Value will be passed to header component to shrink header
    */

    onScroll(event) {
        if (document.getElementById("router-wrap").offsetHeight >= 675) {
            this.scrollYP = event.target.scrollTop;
        }
    }

    /**
     * Scroll the Page to top
    */

    scrollToTop() {
        document.getElementById("divContent").scrollTop = 0;
    }

    /**
     * Left Menu Toggle
    */

    cmdMenuClick(open: boolean) {
        this.start.toggle();
    }


    /**
     * Change Language
    */

    cmdLanguageClick(language: string) {

        try {
            if (this.storageService.getUserState()) {
                this.storageService.setLanguage(language);
                this.getPageContent();
            }
            else {
                this.openDenyModel(MSG_ConfigErr);
            }
        }
        catch (err) {
            this.openAlertModel(err.message);
        }

    }

    /**
     * Change Juris (Anonymous User Only Can Change Juris. Logged In User Cannot Change Juris)
     *
     * Juris List Will not be displayed for Logged In User
    */

    cmdJurisClick(selectedJurisObj: any) {
        try {
            this.storageService.setJurisDetails(selectedJurisObj);
            this.getPageContent();
            this.paramConfigService.LoadSystemParams(this.storageService.getJurisNo());
        }
        catch (err) {
            this.openAlertModel(err.message);
        }
    }

    /**
     * Get Page Content
     *
     * Load PageContent based on the Agency(Juris)
    */

    getPageContent() {
        this.pagecontentService.pageContentYN = true;
        if (this.storageService.getJurisNo()) {

            this.localDataService.getScreensdetail().then((resp)=>{
                this.response=resp;
            })
            this.localDataService.getScreens().then(res => {
                this.scr = res;

                let screenId: number = this.getScreeenID();

                this.pagecontentService.getScreenContent(screenId, this.storageService.getJurisNo()).then(pagecontent => {
                                    
                    this.setPageContent(pagecontent,screenId);
                }).catch(err => { this.pagecontentService.pageContentYN = false;});

            }).catch(err => { this.pagecontentService.pageContentYN = false; });
        }
        else {
            this.pagecontentService.pageContentYN = false;
        }
    }

    // Getting screen id from local data base [query string based route not getting exact screen Id] 
    getScreeenID(): number {
        let screenId: number = 1000;
         
        const url = this.currentPage;
      
       
        if (url.startsWith('/services/servicejobapp')) {
        const parts = url.split('/');
        const result = parts[parts.length - 1]   
        const removespace=result.replace(/%20/g, ' ')
        let extractedValue = removespace;
        
        let screenNameObj = this.response.find(i => i.ScreenName  == extractedValue);

        if(extractedValue== screenNameObj.ScreenName){
            screenId=screenNameObj.ScreenID
             };
        }
else{
    
    if (this.scr.filter(i => i.ScreenRoute == this.currentPage)[0]) {
        screenId = this.scr.filter(i => i.ScreenRoute == this.currentPage)[0].ScreenID;
    }
    else {
        let route: string[] = this.currentPage.split('/');

        if (route.length >= 3) {
            route.splice(3, 1);
            // console.log(route);
            // console.log(route[2]);
            // console.log(this.scr.filter(i => i.ScreenName.replace(' ', '').toLowerCase().includes(route[2])));
            // console.log(this.scr.filter(i => i.ScreenName.replace(' ', '').toLowerCase().includes(route[2]))[0].ScreenID);
            screenId = (this.scr.filter(i => i.ScreenName.replace(' ', '').toLowerCase().includes(route[2]))) ? this.scr.filter(i => i.ScreenName.replace(' ', '').toLowerCase().includes(route[2]))[0].ScreenID : 1000;
        }
    }
}

        return screenId;
    }

    /**
     * Set Page Content
    */

    setPageContent(pageContent: PageContent, ScreenID : any) {
        //console.log(ScreenID);
        if (pageContent) {
            this.pageContent = {
                ScreenID: pageContent.ScreenID,
                ScreenName: pageContent.ScreenName,
                Content: pageContent.Content.filter(item => item.LanguageType === this.storageService.getLang() || item.LanguageType === Lang.English),
                ScreenList: pageContent.ScreenList
            };

            this.pagecontentService.pageContent = this.pageContent;
            //console.log(this.pageContent);
            this.pagecontentService.pageContentYN = false;
        }
        for(let i =0; i<this.pageContent.ScreenList.length; i++){
            if(this.pageContent.ScreenList[i].IsEnabled == false && ScreenID == this.pageContent.ScreenList[i].ScreenID){
                //console.log('inisde');
                this.router.navigateByUrl('/home');
            }
        }
    }


    /**
     * Get User Tenant Details Based on Hostname
    */

    getUserTenantDetails() {

        if (!this.storageService.getTenantState()) {
            this.getTenantDetails(window.location.hostname);
        }
        else {
            this.store.select("parameter").subscribe(paramObject => {
                if (!paramObject) {
                    this.paramConfigService.LoadSystemParams(this.storageService.getJurisNo());
                }
            });
        }
        this.getTenantDetails(window.location.hostname);

    }

    getCodedList(CodeID: number , theme : any) {
            this.codedService.GetCodedDropdownValues(this.storageService.getJurisNo().toString(), CodeID.toString())
                .then(codedList => {
                        //console.log(codedList);
                        for(let i =0; i<codedList.length; i++){
                            if(codedList[i].CodeValue == theme){
                                let color = codedList[i].Description;
                                if(color == 'Red'){
                                    color = '#cf202e'
                                }
                                else if(color == 'Blue'){
                                    color = '#3f5e6d'
                                }
                                this.changeColor(color , codedList[i].Description)
                            }
                        }
                    })
                .catch(err => { });
    }

    changeColor(color: string , jurisTheme : string) {      
        document.documentElement.style.setProperty('--primary', color);
        document.documentElement.style.setProperty('--footer', jurisTheme != 'Blue' ? color : '#607d8b');
        document.documentElement.style.setProperty('--base-footer', jurisTheme != 'Blue'  ? color : '#3b4c55');
        document.documentElement.style.setProperty('--font-and-label', jurisTheme != 'Blue'  ? color : '#03a9f4');
        document.documentElement.style.setProperty('--secondary', jurisTheme != 'Blue'  ? color : '#00bcd4');
        document.documentElement.style.setProperty('--hover-primary', jurisTheme != 'Blue'  ? color : '#039be0');
        document.documentElement.style.setProperty('--hover-secondary', jurisTheme != 'Blue'  ? color : '#00aac0');
        document.documentElement.style.setProperty('--map-filter-hover', jurisTheme != 'Blue'  ? color : '#267ea9');
        document.documentElement.style.setProperty('--table-background', jurisTheme != 'Blue'  ? color : '#2f6c8b');
        document.documentElement.style.setProperty('--label-and-avatar', jurisTheme != 'Blue'  ? color : '#03a8f3');
        document.documentElement.style.setProperty('--sidemenu-header', jurisTheme != 'Blue'  ? color : '#5f7580');

      }


    /**
     * Get Tenant Details
    */

    getTenantDetails(TenantName: string) {
        let hostedJuris: any;

        this.tenantService
            .getTenant(TenantName)
            .then(tenant_response => {
                if (tenant_response && tenant_response.Juris.length > 0) {
                    this.tenant = tenant_response as Tenant;
                    if (window.localStorage.getItem('SelectedAgencyInfo') === "" || window.localStorage.getItem('SelectedAgencyInfo') === null) {
                        if (this.tenant.HostedJurisNo) {
                            hostedJuris = this.tenant.Juris.find(item => item.JurisNo === this.tenant.HostedJurisNo);
                        }
                        else {
                            hostedJuris = this.tenant.Juris[0];
                        }
                    }
                    else {
                        if (window.localStorage.getItem('SelectedAgencyInfo') !== "" || window.localStorage.getItem('SelectedAgencyInfo') !== null) {
                            var AgencyInfo = JSON.parse(window.localStorage.getItem('SelectedAgencyInfo'));
                            hostedJuris = this.tenant.Juris.find(item => item.JurisNo === AgencyInfo.JurisNo);
                        }
                    }

                    if (hostedJuris != undefined) {
                        this.userState = hostedJuris;
                        this.userState.JurisEmail = this.userState.EmailID;
                        this.storageService.setLanguage(this.storageService.getLang()); // Added by Punithavathy for CRM# 81021 on 9/7/18 to set the language while storing tenant details
                        this.storageService.setUserState(this.userState, true);
                        this.storageService.setTenantState(this.tenant);

                        this.paramConfigService.LoadSystemParams(this.storageService.getJurisNo()); // Added by Punithavathy to load System Paramter Configuration

                        this.currentPage = window.location.href.replace(window.location.origin + '/', '').replace('#', '');
                        this.currentPage = ((this.currentPage === '' || this.currentPage.indexOf('/home') !== -1) ? '/home' : this.currentPage); // Modified by Punithavathy for CRM# 81013 on 03/07/18 to load Home pagecontent for the very first time
                        this.getPageContent();
                    } else {
                        this.openDenyModel(MSG_ConfigErr);
                    }
                }
                else {
                    this.openDenyModel(MSG_InactiveConfigErr);
                }
                this.setTheme()

            }
            )
            .catch(err => {
                this.hideStaticTitle = false
                this.openDenyModel(MSG_ConfigErr + "<br/><br/>" + err);
            });
    }

    /**
     * Open Alert Modal
    */

    openAlertModel(msg: string) {

        let dialogRef = this.dialog.open(AlertComponent, {
            disableClose: true,
            panelClass: 'alert-modal',
            data: msg,
        });
    }

    /**
     * Open Deny Modal
    */

    openDenyModel(error: any) {

        this.serviceError();

        let dialogRef = this.dialog.open(DenyComponent, {
            disableClose: false,
            panelClass: 'deny-modal',
            data: error
        });
    }

    /**
     * Open Dashboard Modal
    */

    openDashboardModel() {

        let dialogRef = this.dialog.open(NewsLetterDashboardComponent, {
            disableClose: false
        });
    }
    serviceError() {
        this.serviceErr = true;
    }

    idleUserInitialization() {
        this.userIdle = new UserIdleService({ idle: this.configService.getConfiguration().SessionTimout, timeout: 15, ping: 60 });
        this.userIdle.startWatching();
        // Start watching when user idle is starting.
        this.userIdle.onTimerStart().
            subscribe(count => {
                //console.log('Timer started');
                //console.log(count);
            });
        // Start watch when time is up.
        this.userIdle.onTimeout().
            subscribe(message => {

                //console.log(message);
                //console.log('Time is up!');

                if (this.storageService.getUserRole() == UserRole.Citizen
                    || this.storageService.getUserRole() == UserRole.Juris
                    || this.storageService.getUserRole() == UserRole.Admin
                    || this.storageService.getUserRole() == UserRole.SuperAdmin) {

                    this.logoutSession();
                }

                this.cmdRestartTimer();

            });
    }

    cmdRestartTimer() {
        this.userIdle.stopTimer();
        this.userIdle.stopWatching();
        this.userIdle.startWatching();
        this.userIdle.resetTimer();
    }
    //if idle user session gets expired it redirects to home page
    logoutSession() {

        this.dialog.closeAll();

        let dialogRef = this.dialog.open(AlertComponent, {
            disableClose: true,
            panelClass: 'alert-modal',
            data: { message: 'Your session has been expired, please re-login to proceed further.', showCancelBtn: false }
        });

        dialogRef.afterClosed().subscribe(cmd => {
            if (cmd) {
                if (cmd == 'Ok') {

                    this.dialog.closeAll();

                    //if (this.storageService.getUserRole() == UserRole.Citizen) {
                    this.storageService.logOut();
                    let link = ['home'];
                    this.router.navigate(link);

                    //let dialogRef = this.dialog.open(LoginComponent, {
                    //    disableClose: false,
                    //    panelClass: 'login-modal',
                    //});
                    //}
                    //else if (this.storageService.getUserRole() == UserRole.Admin) {

                    //    this.storageService.logOut();

                    //    this.router.navigateByUrl('/admin/adminlogin');
                    //}

                }
            }
        });

    }
}




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/app.component.ts